/**
 * Dados editados pelo admin (dashboard).
 * Por enquanto em localStorage; depois virão da API.
 */
const PREFIX = 'agendamentos-app:admin:'

export function getAdminData<T>(key: string): T | null {
  try {
    const raw = localStorage.getItem(PREFIX + key)
    return raw ? (JSON.parse(raw) as T) : null
  } catch {
    return null
  }
}

export function setAdminData(key: string, value: unknown): void {
  localStorage.setItem(PREFIX + key, JSON.stringify(value))
}

export const ADMIN_KEYS = {
  menu: 'menu',
  logo: 'logo',
  quemSomos: 'quem-somos',
  servicos: 'servicos',
  tema: 'tema',
  contatos: 'contatos',
  mapa: 'mapa',
  galeria: 'galeria',
  unidades: 'unidades',
  profissionais: 'profissionais',
  pacotes: 'pacotes',
  vip: 'vip',
} as const

/** Chaves da tabela conteudo no BD (para uso com a API) */
export const CONTEUDO_API_KEYS: Record<string, string> = {
  [ADMIN_KEYS.logo]: 'app_logo_url',
  [ADMIN_KEYS.quemSomos]: 'quem_somos',
  [ADMIN_KEYS.servicos]: 'servicos_intro',
  [ADMIN_KEYS.tema]: 'tema_app',
  [ADMIN_KEYS.contatos]: 'contatos',
  [ADMIN_KEYS.mapa]: 'mapa_url',
  [ADMIN_KEYS.vip]: 'vip_texto',
}
